export default __webpack_public_path__ + "static/media/pill_working.79d93d06.png";